import { getSiteAffiliate } from '../utils/affiliate.service';
import {
  getSearchKeyword,
  getSearchPage,
  getSearchPageSize,
  getSearchSort,
} from './search-results.service';

export const generateSearchQuery = (): string => {
  let query: string[] = [];

  query = queryPusher(query, addKeyword());
  query = queryPusher(query, addSort());
  query = queryPusher(query, addPage());
  query = queryPusher(query, addPageSize());
  query = queryPusher(query, addAffiliate());

  return query.join('&');
};

const queryPusher = (query: string[], param: string | undefined): string[] => {
  if (param) {
    query.push(param);
  }
  return query;
};

const addAffiliate = (): string | undefined => {
  const affiliate = getSiteAffiliate();
  return affiliate ? `affiliate=${affiliate}` : undefined;
};

const addKeyword = (): string | undefined => {
  const keyword = getSearchKeyword();
  return keyword ? `keyword=${keyword}` : undefined;
};

const addSort = (): string | undefined => {
  const sort = getSearchSort();
  return sort ? `sort=${sort}` : undefined;
};

const addPage = (): string | undefined => {
  const page = +getSearchPage() - 1;
  return page > 0 ? `page=${page}` : undefined;
};

const addPageSize = (): string | undefined => {
  const pagesize = getSearchPageSize();
  return pagesize ? `pagesize=${pagesize}` : undefined;
};
